<style>
   .icon {
     cursor:pointer
   }
</style>
  
<svg class="icon" viewBox="0 0 30 30" id="_24_-_Up" data-name="24 - Up" xmlns="http://www.w3.org/2000/svg">
  <path id="Path_213" data-name="Path 213" d="M16,1A15,15,0,1,0,31,16,15.007,15.007,0,0,0,16,1Zm0,2A13,13,0,1,1,3,16,13.006,13.006,0,0,1,16,3Z" transform="translate(-1 -1)" fill-rule="evenodd"/>
  <path id="Path_214" data-name="Path 214" d="M10.707,19.707,16,14.414l5.293,5.293a1,1,0,1,0,1.414-1.414l-6-6a1,1,0,0,0-1.414,0l-6,6a1,1,0,0,0,1.414,1.414Z" transform="translate(-1 -1)" fill-rule="evenodd"/>
</svg>